export default "__VITE_ASSET__4JPaRq3G__"